import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../redux/store";
import { IconButton, Typography } from "@mui/material";
import { ArrowBackRounded } from "@mui/icons-material";
import PreviewUser from "../AddUser/PreviewUser";
import { onChangeUsersScreen } from "../../../redux/slices/users.slice";

const ViewUser = () => {
  const { selectedUser } = useSelector((state: RootState) => state.users);
  const dispatch = useDispatch<AppDispatch>();
  return (
    <div className="h-full">
      <div className="flex gap-4 items-center">
        <IconButton onClick={() => dispatch(onChangeUsersScreen("list"))}>
          <ArrowBackRounded />
        </IconButton>
        <Typography className="font-bold" variant="h5">
          View User
        </Typography>
      </div>
      <div className="border border-gray-800 rounded-md px-6 pt-2 pb-6  my-2 h-full flex flex-col gap-6">
        <PreviewUser selectedUser={selectedUser} isView={true} />
      </div>
    </div>
  );
};

export default ViewUser;
